export default "__VITE_ASSET__Dx2SouJk__"